import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "linkSection", "createSection",
    "linkToggle", "createToggle",
    "userIdField", "searchInput", "userList"
  ]

  connect() {
    this.showCreateUser()
  }

  showLinkUser(event) {
    event.preventDefault()
    this.linkSectionTarget.classList.remove("hidden")
    this.createSectionTarget.classList.add("hidden")
    this.linkToggleTarget.classList.add("hidden")
    this.createToggleTarget.classList.remove("hidden")
  }

  showCreateUser(event) {
    if (event) event.preventDefault()
    this.linkSectionTarget.classList.add("hidden")
    this.createSectionTarget.classList.remove("hidden")
    this.linkToggleTarget.classList.remove("hidden")
    this.createToggleTarget.classList.add("hidden")
    this.userIdFieldTarget.value = ""
  }

  filterUsers() {
    const query = this.searchInputTarget.value.toLowerCase().trim()
    const items = this.userListTarget.querySelectorAll("[data-user-item]")

    if (query.length === 0) {
      this.userListTarget.classList.add("hidden")
      return
    }

    let hasResults = false
    items.forEach(item => {
      const name = (item.dataset.userName || "").toLowerCase()
      const email = (item.dataset.userEmail || "").toLowerCase()
      const match = name.includes(query) || email.includes(query)
      item.classList.toggle("hidden", !match)
      if (match) hasResults = true
    })

    this.userListTarget.classList.toggle("hidden", !hasResults)
  }

  selectUser(event) {
    const item = event.currentTarget
    this.userIdFieldTarget.value = item.dataset.userId
    this.searchInputTarget.value = `${item.dataset.userName} (${item.dataset.userEmail})`
    this.userListTarget.classList.add("hidden")
  }

  hideList(event) {
    // Delay so click on list item registers first
    setTimeout(() => {
      if (!this.element.contains(document.activeElement)) {
        this.userListTarget.classList.add("hidden")
      }
    }, 200)
  }
}
